module.exports = __webpack_public_path__ + "assets/images/invisible-asia/1-indonesia.jpg?v=c6dcd374";